import Header from './components/Header';
import Hero from './components/Hero';
import SectionApp from './components/SectionApp';
import SectionUpdates from './components/SectionUpdates';
import SectionMedia from './components/SectionMedia';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionCards from './components/SectionCards';
import SectionTopics from './components/SectionTopics';
import SectionComments from './components/SectionComments';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionFaq from './components/SectionFaq';
import SectionIndex from './components/SectionIndex';
import SectionAbout from './components/SectionAbout';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionApp />
        <SectionUpdates />
        <SectionMedia />
        <SectionCarousel />
        <SectionContact />
        <SectionCards />
        <SectionTopics />
        <SectionComments />
        <SectionFeatures />
        <SectionRanking />
        <SectionFaq />
        <SectionIndex />
        <SectionAbout />
      </main>
      <Footer />
    </>
  );
}